// extracted by mini-css-extract-plugin
export default {"voopoBtn":"Button_voopoBtn__O46cU","voopoBtnLight":"Button_voopoBtnLight__IHvIT","voopoBtnWhite":"Button_voopoBtnWhite__aG2o1"};